import { operations } from '@sparling/financial-common'

const operationsList = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item of operations) {
  operationsList.push({
    value: item,
    label: item,
  })
}

export const OPERATIONS = operationsList
